export default __webpack_public_path__ + "static/media/action-plan-icon.ae8498fa.svg";